<div #anchorRef>
  <sd-item-wrapper (click)="ngbDatepicker.toggle()">другой день</sd-item-wrapper>
</div>

<input
  ngbDatepicker
  #ngbDatepicker="ngbDatepicker"
  class="input-date-picker"
  (dateSelect)="onDateSelect($event)"
  [positionTarget]="anchorRef"
  [minDate]="dateRange().min"
  [maxDate]="dateRange().max"
  navigation="arrows"
/>
